// Get Analytics Campaign Modifiers
export const GET_ANALYTICS_CAMPAIGN_MODIFIERS_REQUEST = 'GET_ANALYTICS_CAMPAIGN_MODIFIERS_REQUEST';
export const GET_ANALYTICS_CAMPAIGN_MODIFIERS_DONE = 'GET_ANALYTICS_CAMPAIGN_MODIFIERS_DONE';
export const GET_ANALYTICS_CAMPAIGN_MODIFIERS_FAILED = 'GET_ANALYTICS_CAMPAIGN_MODIFIERS_FAILED';
export const GET_ANALYTICS_CAMPAIGN_MODIFIERS_RESET = 'GET_ANALYTICS_CAMPAIGN_MODIFIERS_RESET';

//Operations
export const ANALYTICS_CAMPAIGN_MODIFIERS_SET_PAGE = 'ANALYTICS_CAMPAIGN_MODIFIERS_SET_PAGE';
